// SAT Bildkollektion — Asset Manifest
// Basierend auf: SAT_Bildkollektion_Emergent_Masterauftrag_v1.0_2026-08-21.docx
//
// Jedes Bild trägt eine feste Motiv-ID (z.B. FRA-01, ELT-02).
// Aktuell: PLACEHOLDER-Bilder aus Unsplash Editorial (natürliches Licht, keine Werbeposen).
// TODO: Nach eigener Produktion (Editorial DACH · siehe Masterauftrag) URLs ersetzen.
//
// Format-Regel:
//  - hero  : 16:9 Desktop-Hero
//  - mobile: 4:5 Mobile-Hero
//  - card  : 3:2 Support / Card
//  - og    : 1200x630 Open Graph
//
// approved: true  → darf ausgeliefert werden (Rechte-Status geprüft)
// approved: false → nur intern (DRAFT)

export const IMAGE_ASSETS = {
  // ─── SAT Stimmen™ · Hero-Motive ─────────────────────────────────
  "FRA-01": {
    id: "FRA-01",
    product: "frauenstimme",
    kind: "hero",
    src: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=2400&q=80",
    src_mobile: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=1200&h=1500&q=80",
    alt: "Frau mit ruhigem, präsentem Blick in warmem Licht",
    focal: { x: 0.6, y: 0.4 },
    accent: "#8E4A6E",
    approved: false,
    placeholder: true,
    caption: "Frauenstimme · Hero",
  },
  "MAN-01": {
    id: "MAN-01",
    product: "maennerstimme",
    kind: "hero",
    src: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=2400&q=80",
    src_mobile: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=1200&h=1500&q=80",
    alt: "Mann in ruhiger Selbstbegegnung, geerdet",
    focal: { x: 0.5, y: 0.4 },
    accent: "#2E5C3E",
    approved: false,
    placeholder: true,
    caption: "Männerstimme · Hero",
  },
  "MUT-01": {
    id: "MUT-01",
    product: "mutterstimme",
    kind: "hero",
    // 2026-02-25 · Auftrag Pkt 1 · Warmherzige, sympathische Mutter (weisse Frau).
    src: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=2400&q=80",
    src_mobile: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=1200&h=1500&q=80",
    alt: "Warmherzige, sympathisch strahlende Mutter — natürliche Präsenz",
    focal: { x: 0.5, y: 0.4 },
    accent: "#C9A36A",
    approved: true,
    placeholder: false,
    caption: "Mutterstimme · Hero",
  },
  "VAT-01": {
    id: "VAT-01",
    product: "vaterstimme",
    kind: "hero",
    // 2026-02-25 · Auftrag Pkt 2 · Reifer Mann mit warmer Vaterausstrahlung.
    src: "https://images.unsplash.com/photo-1552058544-f2b08422138a?auto=format&fit=crop&w=2400&q=80",
    src_mobile: "https://images.unsplash.com/photo-1552058544-f2b08422138a?auto=format&fit=crop&w=1200&h=1500&q=80",
    alt: "Reifer, warmherziger Vater in ruhiger, klarer Präsenz",
    focal: { x: 0.5, y: 0.4 },
    accent: "#4B2E83",
    approved: true,
    placeholder: false,
    caption: "Vaterstimme · Hero",
  },
  "KIN-01": {
    id: "KIN-01",
    product: "kinderstimme",
    kind: "hero",
    // 2026-02-25 · Auftrag Pkt 2 · Kind am Strahlen, Lachen in den Augen erkennbar.
    src: "https://images.unsplash.com/photo-1519689680058-324335c77eba?auto=format&fit=crop&w=2400&q=80",
    src_mobile: "https://images.unsplash.com/photo-1519689680058-324335c77eba?auto=format&fit=crop&w=1200&h=1500&q=80",
    alt: "Strahlend lachendes Kind — Freude in den Augen",
    focal: { x: 0.5, y: 0.5 },
    accent: "#8B7BB8",
    approved: true,
    placeholder: false,
    caption: "Kinderstimme · Hero",
  },
  "ELT-01": {
    id: "ELT-01",
    product: "elternstimme",
    kind: "hero",
    src: "https://images.unsplash.com/photo-1511895426328-dc8714191300?auto=format&fit=crop&w=2400&q=80",
    src_mobile: "https://images.unsplash.com/photo-1511895426328-dc8714191300?auto=format&fit=crop&w=1200&h=1500&q=80",
    alt: "Zwei Erwachsene als Elternteam im bewussten Miteinander",
    focal: { x: 0.5, y: 0.4 },
    accent: "#D4AF37",
    approved: false,
    placeholder: true,
    caption: "Elternstimme · Hero",
  },
};

/**
 * Look up an asset by motif id. Returns null when not found so callers can
 * fail gracefully.
 */
export const getAsset = (id) => IMAGE_ASSETS[id] || null;
